import MainLayout from '../layouts/main';
import ExamReportContainer from './container';

function ReportPage() {
  return (
    <MainLayout>
      <ExamReportContainer/>
    </MainLayout>
  );
}

export default ReportPage;

